// extracted by mini-css-extract-plugin
module.exports = {"Inside":"PuzzleBuilder_Inside__6gZXO","Back":"PuzzleBuilder_Back__2HCbX"};